import { useDetectGPU } from '@react-three/drei'
import { useState, useEffect } from 'react'

const useBrowserDetection = () => {

    const {isMobile} = useDetectGPU()
    const [browser, setBrowser] = useState('')

    useEffect(() => {
        if(isMobile === true){
            return null
        }else{
            const browser = (function (agent) {
                switch (true) {
                    case agent.indexOf("edge") > -1: return "edge";
                    case agent.indexOf("edg") > -1: return "edge";
                    case agent.indexOf("opr") > -1 && !!window.opr: return "opera";
                    case agent.indexOf("chrome") > -1 && !!window.chrome: return "chrome";
                    case agent.indexOf("trident") > -1: return "ie";
                    case agent.indexOf("firefox") > -1: return "firefox";
                    case agent.indexOf("safari") > -1: return "safari";
                    default: return "other";
                }
            })(window.navigator.userAgent.toLowerCase());
            setBrowser(browser)
        }
        
    }, [])

    return {
        browser : browser , 
        isMobile : isMobile
    }
    
}

export default useBrowserDetection
